"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingDrawer = void 0;
var jsx_runtime_1 = require("preact/jsx-runtime");
var hooks_1 = require("preact/hooks");
var helper_1 = require("../../helper");
var DrawerHeader_1 = require("../DrawerHeader");
require("./index.css");
var requests_1 = require("../../requests");
var DrawerFooter_1 = require("../DrawerFooter");
var TrackingShipment_1 = require("../TrackingShipment");
var SelectTrackingShipment_1 = require("../SelectTrackingShipment");
var TrackingDrawer = function (_a) {
    var shipmentIds = _a.shipmentIds, config = _a.config, onClose = _a.onClose;
    var position = config.style.position;
    var style = (0, helper_1.getTrackingStyle)(config);
    var _b = (0, hooks_1.useState)(null), shipments = _b[0], setShipments = _b[1];
    var _c = (0, hooks_1.useState)(null), selectedShipment = _c[0], setSelectedShipment = _c[1];
    (0, hooks_1.useEffect)(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var ships;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(shipmentIds.map(function (shipmentId) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, (0, requests_1.loadShipment)(config, shipmentId)];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); }))];
                    case 1:
                        ships = _a.sent();
                        setShipments(ships);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [shipmentIds]);
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", { class: "artajs", children: [config.style.backdropEnabled && ((0, jsx_runtime_1.jsx)("div", { onClick: onClose, style: style, class: "artajs__drawer__backdrop" })), (0, jsx_runtime_1.jsx)("div", { style: style, class: "artajs__drawer ".concat(position === 'left'
                        ? 'artajs__drawer__left'
                        : 'artajs__drawer__right'), children: (0, jsx_runtime_1.jsxs)("div", { class: "artajs__tracking__out__wrapper", children: [(0, jsx_runtime_1.jsx)(DrawerHeader_1.DrawerHeader, { title: selectedShipment
                                    ? config.text.header.titleShipmentDetail
                                    : shipments && shipments.length > 1
                                        ? config.text.header.titleShipmentList
                                        : config.text.header.title, onClose: onClose, setSelectedShipment: setSelectedShipment, multiple: !!selectedShipment, config: config }), (shipments === null || shipments === void 0 ? void 0 : shipments.length) ? (shipments.length === 1 || selectedShipment ? ((0, jsx_runtime_1.jsx)(TrackingShipment_1.TrackingShipment, { shipment: selectedShipment !== null && selectedShipment !== void 0 ? selectedShipment : shipments[0], config: config })) : ((0, jsx_runtime_1.jsx)(SelectTrackingShipment_1.SelectTrackingShipment, { shipments: shipments, config: config, setSelectedShipment: setSelectedShipment }))) : ((0, jsx_runtime_1.jsxs)("div", { class: "artajs__tracking__body", children: [(0, jsx_runtime_1.jsx)("div", { class: "artajs__drawer__loading" }), (0, jsx_runtime_1.jsx)(DrawerFooter_1.DrawerFooter, {})] }))] }) })] }) }));
};
exports.TrackingDrawer = TrackingDrawer;
